/* Google Formulare Popup (JOBS)
   Rendert Google Formulare aus der Apps Script Definition im Lost and Found Design.
   Kein Captcha: Absenden geht direkt an die Apps Script Web App.
   Beim Seitenaufruf werden Liste und alle Definitionen in einem Aufruf vorgeladen (action=all),
   der Klick auf einen Button oeffnet das Formular dann ohne Wartezeit.
   Aufruf aus der Section: GoogleFormsPopup.init({ ... }) */
(function () {
  'use strict';

  var T = {
    laden: 'FORMULAR WIRD GELADEN ...',
    weiter: 'WEITER',
    zurueck: 'ZURÜCK',
    absenden: 'ABSENDEN',
    sendet: 'SENDET...',
    schliessen: 'SCHLIESSEN',
    danke: 'VIELEN DANK!',
    pflicht: 'Bitte fülle alle Pflichtfelder (*) aus.',
    datenschutz: 'Bitte bestätige den Datenschutzhinweis.',
    netz: 'Verbindung fehlgeschlagen. Bitte versuche es später noch einmal.',
    ladenFehler: 'Das Formular konnte nicht geladen werden.',
    verwerfen: 'Eingaben verwerfen und schließen?',
    sonstiges: 'Sonstiges',
    sonstigesPlatzhalter: 'Bitte angeben',
    bitteWaehlen: '-- Bitte auswählen --'
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function el(html) {
    var t = document.createElement('template');
    t.innerHTML = html.trim();
    return t.content.firstChild;
  }

  // ---------------------------------------------------------------- Widget
  function Widget(cfg) {
    this.cfg = cfg;
    this.endpoint = cfg.endpoint || '';
    this.teaser = document.getElementById('gfp-teaser-' + cfg.sectionId);
    this.overlay = document.getElementById('gfp-overlay-' + cfg.sectionId);
    if (!this.teaser || !this.overlay) return;

    this.untertitel = this.teaser.querySelector('[data-gfp-untertitel]');
    this.buttons = this.teaser.querySelector('[data-gfp-buttons]');
    this.offline = this.teaser.querySelector('[data-gfp-offline]');
    this.laden = this.teaser.querySelector('[data-gfp-laden]');
    this.titel = this.overlay.querySelector('[data-gfp-titel]');
    this.body = this.overlay.querySelector('[data-gfp-body]');
    this.fehler = this.overlay.querySelector('[data-gfp-fehler]');
    this.fehlerText = this.overlay.querySelector('[data-gfp-fehler-text]');
    this.progress = this.overlay.querySelector('[data-gfp-progress]');
    this.modal = this.overlay.querySelector('[data-gfp-modal]');

    this.definitionen = {};
    this.schritte = [];
    this.offen = false;
    this.dirty = false;
    this.fertig = false;

    var self = this;
    this.overlay.querySelector('[data-gfp-close]').addEventListener('click', function () { self.schliesse(); });
    this.overlay.addEventListener('click', function (e) { if (e.target === self.overlay) self.schliesse(); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (self.modal.classList.contains('gfp-modal--offen')) self.modalSchliessen();
      else self.schliesse();
    });
    this.modal.querySelectorAll('[data-gfp-modal-close]').forEach(function (b) {
      b.addEventListener('click', function () { self.modalSchliessen(); });
    });
    this.modal.addEventListener('click', function (e) { if (e.target === self.modal) self.modalSchliessen(); });
    this.body.addEventListener('input', function () { self.dirty = true; });
    this.body.addEventListener('change', function () { self.dirty = true; });

    this.ladeListe();
  }

  // ---------- Liste und Teaser
  // Ein Aufruf holt Liste plus Definitionen. Solange er laeuft, zeigt der Teaser den Ladebalken.
  Widget.prototype.ladeListe = function () {
    var self = this;
    if (!this.endpoint || this.endpoint.indexOf('script.google.com') === -1) { this.zeigeOffline(); return; }
    if (this.laden) this.laden.classList.remove('gfp-hidden');
    this.get({ action: 'all' }).then(function (status) { self.zeigeListe(status); }, function () { self.zeigeOffline(); });
  };

  Widget.prototype.zeigeOffline = function () {
    if (this.laden) this.laden.classList.add('gfp-hidden');
    this.untertitel.classList.add('gfp-hidden');
    this.buttons.classList.add('gfp-hidden');
    this.offline.classList.remove('gfp-hidden');
  };

  Widget.prototype.zeigeListe = function (status) {
    var self = this;
    var forms = (status && status.active === true && Array.isArray(status.forms)) ? status.forms : [];
    forms = forms.filter(function (f) { return f && f.key && f.title; });
    if (!forms.length) { this.zeigeOffline(); return; }
    forms.forEach(function (f) { if (f.definition) self.definitionen[f.key] = f.definition; });
    if (this.laden) this.laden.classList.add('gfp-hidden');

    this.buttons.innerHTML = '';
    forms.forEach(function (f) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gfp-teaser-button';
      b.textContent = f.title;
      b.addEventListener('click', function () { self.oeffne(f); });
      self.buttons.appendChild(b);
    });
    this.offline.classList.add('gfp-hidden');
    if (this.untertitel.textContent.trim()) this.untertitel.classList.remove('gfp-hidden');
    this.buttons.classList.remove('gfp-hidden');
  };

  // ---------- Transport
  Widget.prototype.url = function (params) {
    var q = Object.keys(params).map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]); }).join('&');
    return this.endpoint + (this.endpoint.indexOf('?') === -1 ? '?' : '&') + q;
  };

  Widget.prototype.get = function (params) {
    var self = this;
    return fetch(this.url(params), { redirect: 'follow', cache: 'no-store' })
      .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
      .catch(function () { return self.jsonp(params); });
  };

  // Fallback, falls fetch am Google Redirect scheitert
  Widget.prototype.jsonp = function (params) {
    var self = this;
    return new Promise(function (resolve, reject) {
      var name = 'gfpCb_' + Math.random().toString(36).slice(2);
      var p = {};
      Object.keys(params).forEach(function (k) { p[k] = params[k]; });
      p.callback = name;
      window[name] = function (data) { delete window[name]; resolve(data); };
      var tag = document.createElement('script');
      tag.src = self.url(p);
      tag.onerror = function () { delete window[name]; reject(new Error('jsonp')); };
      document.head.appendChild(tag);
    });
  };

  Widget.prototype.post = function (daten) {
    return fetch(this.endpoint, {
      method: 'POST',
      redirect: 'follow',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(daten)
    }).then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); });
  };

  // ---------- Overlay
  Widget.prototype.oeffne = function (form) {
    var self = this;
    this.aktuell = form;
    this.dirty = false;
    this.fertig = false;
    this.titel.textContent = form.title;
    this.fehlerAus();
    this.progress.style.width = '0%';
    this.body.innerHTML = this.definitionen[form.key] ? '' : '<div class="gfp-wait">' + esc(T.laden) + '</div>';

    document.body.style.overflow = 'hidden';
    this.overlay.scrollTop = 0;
    this.overlay.classList.add('gfp-overlay--offen');
    this.offen = true;
    setTimeout(function () { self.overlay.classList.add('gfp-overlay--sichtbar'); }, 10);

    var laden = this.definitionen[form.key]
      ? Promise.resolve(this.definitionen[form.key])
      : this.get({ action: 'form', key: form.key }).then(function (def) {
          if (!def || def.status === 'error') throw new Error((def && def.message) || T.ladenFehler);
          self.definitionen[form.key] = def;
          return def;
        });

    laden.then(function (def) { if (self.offen) self.rendere(def); }, function (err) {
      self.body.innerHTML = '';
      self.fehlerAn(err && err.message ? err.message : T.ladenFehler);
    });
  };

  Widget.prototype.schliesse = function () {
    if (!this.offen) return;
    if (this.dirty && !this.fertig && !window.confirm(T.verwerfen)) return;
    var self = this;
    this.offen = false;
    document.body.style.overflow = '';
    this.overlay.classList.remove('gfp-overlay--sichtbar');
    setTimeout(function () {
      self.overlay.classList.remove('gfp-overlay--offen');
      self.body.innerHTML = '';
      self.schritte = [];
    }, 300);
  };

  Widget.prototype.fehlerAn = function (text) {
    this.fehlerText.textContent = text;
    this.fehler.classList.remove('gfp-hidden');
    this.overlay.scrollTop = 0;
  };
  Widget.prototype.fehlerAus = function () { this.fehler.classList.add('gfp-hidden'); };

  Widget.prototype.modalOeffnen = function () {
    var self = this;
    this.modal.classList.add('gfp-modal--offen');
    setTimeout(function () { self.modal.classList.add('gfp-modal--sichtbar'); }, 10);
  };
  Widget.prototype.modalSchliessen = function () {
    var self = this;
    this.modal.classList.remove('gfp-modal--sichtbar');
    setTimeout(function () { self.modal.classList.remove('gfp-modal--offen'); }, 300);
  };

  // ---------- Rendern
  Widget.prototype.rendere = function (def) {
    var self = this;
    this.body.innerHTML = '';
    if (def.renderable === false) { this.fehlerAn(def.message || T.ladenFehler); return; }

    this.schritte = [];
    if (def.description) {
      this.schritte.push(el('<div class="gfp-step"><div class="gfp-intro">' + esc(def.description) + '</div></div>'));
    }
    (def.steps || []).forEach(function (step) {
      var s = el('<div class="gfp-step"></div>');
      if (step.title) s.appendChild(el('<h3 class="gfp-step-title">' + esc(step.title) + '</h3>'));
      if (step.description) s.appendChild(el('<p class="gfp-step-intro">' + esc(step.description) + '</p>'));
      (step.items || []).forEach(function (feld) { s.appendChild(self.feld(feld)); });
      self.schritte.push(s);
    });
    this.schritte.push(this.letzterSchritt());

    this.schritte.forEach(function (s, i) {
      var letzter = i === self.schritte.length - 1;
      var nav = el('<div class="gfp-nav' + (i === 0 ? ' gfp-nav--end' : '') + '"></div>');
      if (i > 0) {
        var back = el('<button type="button" class="gfp-btn gfp-btn--nav">&lsaquo; ' + esc(T.zurueck) + '</button>');
        back.addEventListener('click', function () { self.gehe(i - 1); });
        nav.appendChild(back);
      }
      if (!letzter) {
        var next = el('<button type="button" class="gfp-btn gfp-btn--next">' + esc(T.weiter) + ' &rsaquo;</button>');
        next.addEventListener('click', function () { if (self.pruefeSchritt(i)) self.gehe(i + 1); });
        nav.appendChild(next);
      } else {
        var submit = el('<button type="button" class="gfp-btn gfp-btn--submit">&#10148; ' + esc(T.absenden) + '</button>');
        submit.addEventListener('click', function () { self.absenden(submit); });
        nav.appendChild(submit);
      }
      s.appendChild(nav);
      self.body.appendChild(s);
    });
    this.gehe(0);
  };

  Widget.prototype.gehe = function (index) {
    var self = this;
    this.fehlerAus();
    this.schritte.forEach(function (s) { s.classList.remove('gfp-step--aktiv'); });
    setTimeout(function () {
      if (!self.schritte[index]) return;
      self.schritte[index].classList.add('gfp-step--aktiv');
      self.progress.style.width = Math.round(((index + 1) / self.schritte.length) * 100) + '%';
      self.overlay.scrollTop = 0;
    }, 200);
  };

  // Ein Feld nach Typ
  Widget.prototype.feld = function (f) {
    if (f.type === 'header') {
      return el('<div class="gfp-header"><h4>' + esc(f.title) + '</h4>' + (f.help ? '<p>' + esc(f.help) + '</p>' : '') + '</div>');
    }
    var id = 'gfp-' + this.cfg.sectionId + '-' + f.id;
    var name = id;
    var wrap = el('<div class="gfp-field" data-gfp-item="' + esc(f.id) + '" data-gfp-type="' + esc(f.type) + '"' + (f.required ? ' data-gfp-required="1"' : '') + '></div>');
    wrap.appendChild(el('<label class="gfp-label" for="' + id + '">' + esc(f.title) + (f.required ? ' *' : '') + '</label>'));
    if (f.help) wrap.appendChild(el('<span class="gfp-help">' + esc(f.help) + '</span>'));

    switch (f.type) {
      case 'TEXT':
        wrap.appendChild(el('<input type="' + (/mail/i.test(f.title) ? 'email' : 'text') + '" id="' + id + '" class="gfp-input" autocomplete="off">'));
        break;
      case 'PARAGRAPH_TEXT':
        wrap.appendChild(el('<textarea id="' + id + '" class="gfp-input" rows="4"></textarea>'));
        break;
      case 'MULTIPLE_CHOICE':
      case 'CHECKBOX': {
        var typ = f.type === 'CHECKBOX' ? 'checkbox' : 'radio';
        var box = el('<div class="gfp-choices"></div>');
        (f.choices || []).forEach(function (c) {
          box.appendChild(el('<label class="gfp-choice"><input type="' + typ + '" name="' + name + '" value="' + esc(c) + '"><span>' + esc(c) + '</span></label>'));
        });
        if (f.other) {
          box.appendChild(el('<label class="gfp-choice"><input type="' + typ + '" name="' + name + '" value="__other__" data-gfp-other><span>' + esc(T.sonstiges) + '</span></label>'));
        }
        wrap.appendChild(box);
        if (f.other) {
          var other = el('<div class="gfp-other gfp-hidden"><input type="text" class="gfp-input" data-gfp-other-text placeholder="' + esc(T.sonstigesPlatzhalter) + '"></div>');
          wrap.appendChild(other);
          box.addEventListener('change', function () {
            var o = box.querySelector('[data-gfp-other]');
            other.classList.toggle('gfp-hidden', !(o && o.checked));
          });
        }
        break;
      }
      case 'LIST': {
        var sel = el('<select id="' + id + '" class="gfp-input"><option value="">' + esc(T.bitteWaehlen) + '</option></select>');
        (f.choices || []).forEach(function (c) { sel.appendChild(el('<option value="' + esc(c) + '">' + esc(c) + '</option>')); });
        wrap.appendChild(sel);
        break;
      }
      case 'SCALE': {
        var sc = f.scale || { lower: 1, upper: 5, leftLabel: '', rightLabel: '' };
        var row = el('<div class="gfp-choices gfp-choices--scale"></div>');
        for (var n = sc.lower; n <= sc.upper; n++) {
          row.appendChild(el('<label class="gfp-choice gfp-choice--scale"><input type="radio" name="' + name + '" value="' + n + '"><span>' + n + '</span></label>'));
        }
        wrap.appendChild(row);
        if (sc.leftLabel || sc.rightLabel) {
          wrap.appendChild(el('<div class="gfp-scale-labels"><span>' + esc(sc.leftLabel) + '</span><span>' + esc(sc.rightLabel) + '</span></div>'));
        }
        break;
      }
      case 'DATE':
        wrap.appendChild(el('<input type="date" id="' + id + '" class="gfp-input">'));
        break;
      case 'TIME':
        wrap.appendChild(el('<input type="time" id="' + id + '" class="gfp-input">'));
        break;
      case 'DATETIME':
        wrap.appendChild(el('<input type="datetime-local" id="' + id + '" class="gfp-input">'));
        break;
    }
    return wrap;
  };

  // Wert eines Feldes lesen: String, Array oder null
  Widget.prototype.wert = function (wrap) {
    var typ = wrap.getAttribute('data-gfp-type');
    if (typ === 'MULTIPLE_CHOICE' || typ === 'CHECKBOX' || typ === 'SCALE') {
      var werte = [];
      wrap.querySelectorAll('input:checked').forEach(function (i) {
        if (i.hasAttribute('data-gfp-other')) {
          var t = wrap.querySelector('[data-gfp-other-text]');
          if (t && t.value.trim()) werte.push(t.value.trim());
        } else {
          werte.push(i.value);
        }
      });
      if (!werte.length) return null;
      return typ === 'CHECKBOX' ? werte : werte[0];
    }
    var input = wrap.querySelector('input, textarea, select');
    var v = input ? String(input.value).trim() : '';
    return v ? v : null;
  };

  Widget.prototype.pruefeSchritt = function (index) {
    var self = this;
    var ok = true;
    this.schritte[index].querySelectorAll('[data-gfp-required]').forEach(function (wrap) {
      if (self.wert(wrap) === null) ok = false;
    });
    if (!ok) { this.fehlerAn(T.pflicht); return false; }
    this.fehlerAus();
    return true;
  };

  Widget.prototype.antworten = function () {
    var self = this;
    var out = {};
    this.body.querySelectorAll('[data-gfp-item]').forEach(function (wrap) {
      var v = self.wert(wrap);
      if (v !== null) out[wrap.getAttribute('data-gfp-item')] = v;
    });
    return out;
  };

  // Letzter Schritt: Datenschutz und Absenden
  Widget.prototype.letzterSchritt = function () {
    var self = this;
    var s = el('<div class="gfp-step"></div>');
    var priv = el(
      '<div class="gfp-privacy"><label><input type="checkbox" data-gfp-privacy>' +
      '<span>Ich habe den <button type="button" class="gfp-link" data-gfp-privacy-link>Datenschutzhinweis</button> gelesen und akzeptiere diesen. *</span></label></div>'
    );
    priv.querySelector('[data-gfp-privacy-link]').addEventListener('click', function (e) { e.preventDefault(); self.modalOeffnen(); });
    s.appendChild(priv);
    return s;
  };

  Widget.prototype.absenden = function (button) {
    var self = this;
    var letzter = this.schritte.length - 1;
    if (!this.body.querySelector('[data-gfp-privacy]').checked) { this.fehlerAn(T.datenschutz); return; }
    // Alle Schritte nochmal pruefen, falls jemand zurueck gesprungen ist und Felder geleert hat
    for (var i = 0; i < letzter; i++) {
      if (!this.pruefeSchritt(i)) { this.gehe(i); this.fehlerAn(T.pflicht); return; }
    }
    this.fehlerAus();

    var original = button.innerHTML;
    button.disabled = true;
    button.innerHTML = '<span class="gfp-loading"><span class="gfp-loading__text">' + esc(T.sendet) + '</span><span class="gfp-loading__track"><span class="gfp-loading__bar"></span></span></span>';

    this.post({ action: 'submit', key: this.aktuell.key, answers: this.antworten() })
      .then(function (res) {
        if (!res || res.status !== 'success') throw new Error((res && res.message) || T.netz);
        self.erfolg();
      })
      .catch(function (err) {
        button.disabled = false;
        button.innerHTML = original;
        self.fehlerAn(err && err.message && err.message.indexOf('HTTP') !== 0 && err.message !== 'Failed to fetch' ? err.message : T.netz);
      });
  };

  Widget.prototype.erfolg = function () {
    var self = this;
    var def = this.definitionen[this.aktuell.key] || {};
    var text = def.confirmation || this.cfg.successFallback || '';
    this.fertig = true;
    this.dirty = false;
    this.progress.style.width = '100%';
    this.body.innerHTML = '';
    this.schritte = [];
    var box = el('<div class="gfp-success"><span class="gfp-success__icon">&#10004;</span><h3>' + esc(T.danke) + '</h3><p>' + esc(text) + '</p></div>');
    var close = el('<button type="button" class="gfp-btn gfp-btn--wide">' + esc(T.schliessen) + '</button>');
    close.addEventListener('click', function () { self.schliesse(); });
    box.appendChild(close);
    this.body.appendChild(box);
    setTimeout(function () { box.classList.add('gfp-success--sichtbar'); }, 50);
    this.overlay.scrollTop = 0;
  };

  window.GoogleFormsPopup = {
    init: function (cfg) { return new Widget(cfg); }
  };
})();
